import React from "react"
import "./RecomendacionCard.css"

interface Props {
  children: React.ReactNode
}

const RecomendacionCard: React.FC<Props> = ({ children }) => {
  return <div className="recommendation-card">{children}</div>
}

export default RecomendacionCard
